"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainContract = void 0;
const ethers_1 = require("ethers");
const __1 = require("../");
const abi_1 = require("./abi");
class ChainContract {
    constructor(web3Provider, chainContractAddress) {
        if (!chainContractAddress) {
            throw Error('chainContractAddress is empty');
        }
        this.contract = new ethers_1.ethers.Contract(chainContractAddress, abi_1.chainAbi, web3Provider);
    }
    async verifyProofForBlock(blockId, proof, key, value) {
        return await this.contract.verifyProofForBlock(blockId, proof, __1.LeafKeyCoder.encode(key), value);
    }
}
exports.ChainContract = ChainContract;
//# sourceMappingURL=Chain.js.map